export default class Source {
    // static address = 'http://127.0.0.1:8000';
    static address = 'https://ilyassoft.com';
    static getAddress() {
        return this.address;
    }
}
